import { render } from "./CreateReportFormModal.vue?vue&type=template&id=3fced825&scoped=true&ts=true"
import script from "./CreateReportFormModal.vue?vue&type=script&lang=ts"
export * from "./CreateReportFormModal.vue?vue&type=script&lang=ts"

import "./CreateReportFormModal.vue?vue&type=style&index=0&id=3fced825&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ivans_tvajpyr\\msoft\\frontend\\rvirao\\frontend\\editor-forms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fced825"]])

export default __exports__